import { render, staticRenderFns } from "./BirdStockList.vue?vue&type=template&id=30470ea2&scoped=true&"
import script from "./BirdStockList.vue?vue&type=script&lang=js&"
export * from "./BirdStockList.vue?vue&type=script&lang=js&"
import style1 from "./BirdStockList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30470ea2",
  null
  
)

export default component.exports